import { runDemo } from "../shared/demoRunner";
import { createSSAOScene } from "./scene";

runDemo({ createScene: createSSAOScene });
